const Footer = () => {
    return (
        <div className="Footer">
            <div>adderess</div>
            <div>asldkfja;lskdjfasljfkd</div>
            <hr style={{ borderColor: "gray" }}></hr>
            <div className="contactInfo">
                <a href="https://github.com/heal333" target="_blank">
                    Github
                </a>
                <a href="https://linkedin.com/in/rohanaich" target="_blank">
                    Linkedin
                </a>
                <a href="mailto:rohanaich333@gmail.com" target="_blank">
                    email
                </a>
            </div>
        </div>
    );
};

export default Footer;
